import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { GENERAL } from '@shared/constants';

@Component({
  selector: 'howden-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet]
})
export class AppComponent {
  title = GENERAL.AppName;
}
